
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 255.4 255.2"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('path',{attrs:{"id":"a","d":"M-.3-.5h256v256H-.3z"}})]),_c('clipPath',{attrs:{"id":"b"}},[_c('use',{attrs:{"xlink:href":"#a","overflow":"visible"}})]),_c('g',{attrs:{"clip-path":"url(#b)"}},[_c('path',{attrs:{"d":"M254.4 113.4c-.2-1.3-.3-2.7-.5-4.1-10.1-69.7-74.8-118.1-144.6-108C39.5 11.4-8.8 76.1 1.3 145.9c9.1 62.8 62.9 109.4 126.4 109.3 1.1 0 2.3 0 3.4-.2 69.1-1.8 124.2-58.3 124.3-127.5-.1-4.7-.4-9.4-1-14.1z"}}),_c('path',{attrs:{"d":"M139.9 117.6l47.6-55.3h-11.3l-41.3 48-33-48H63.8l49.9 72.6-49.9 58h11.3l43.6-50.7 34.8 50.7h38.1l-51.7-75.3zm-15.5 17.9l-5.1-7.2-40.2-57.5h17.3l32.5 46.4 5.1 7.2 42.2 60.4h-17.3l-34.4-49.2z","fill":"#fff"}})])])
          )
        }
      }
    